import styled from '@emotion/styled';
import {Box, Divider, Typography} from '@mui/material';

import WakaoLogo from '../../../../asset/logo.jpg';
import FooterDotsIcon from '../../../../asset/backgrounds/footerdots.svg';
import FooterVectorIcon from '../../../../asset/backgrounds/footer_1.svg';
import {useDeviceDetect} from '../../../Utils';
import {useNavigate} from 'react-router-dom';

const FooterContainer = styled(Box)<{ isMobile: Boolean }>`
  padding: ${(props) => (props.isMobile ? '50px 20px' : '80px 50px')};
  background-color: #ffffff;
  position: relative;
  display: flex;
  flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};
  align-items: center;
  justify-content: ${(props) => (props.isMobile ? 'center' : 'flex-start')};
  // z-index: -5;
`;
const FooterVector = styled.img<{ isMobile: Boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => (props.isMobile ? '228px' : '451px')};
  // z-index: -1;
`;
const FooterDots = styled.img<{ isMobile: Boolean }>`
  position: absolute;
  transform: ${(props) => props.isMobile && 'rotate(90deg)'};
  bottom: ${(props) => (props.isMobile ? '64px' : '32px')};
  right: ${(props) => (props.isMobile ? '-36px' : '32px')};
`;

const Block1HeadingSmall = styled(Typography)<{ isMobile: Boolean }>`
  width: 100%;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: ${(props) => (props.isMobile ? '14px' : '22px')};
  line-height: ${(props) => (props.isMobile ? '28px' : '52px')};
  color: #000000;
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.isMobile && 'center'};
  text-align: ${(props) => props.isMobile && 'center'};
  margin-top: 20px;
  align-items: center;
`;

const LinkText = styled(Typography)<{ isMobile: Boolean }>`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.5px;
  color: #000000;
  cursor: pointer;
  margin-top: ${(props) => (props.isMobile ? '24px' : '0')};
  text-align: center;
  display: inline-block;
  text-decoration: none;

  &:hover {
    &:after {
      width: 100%;
    }
  }

  &:after {
    content: '';
    display: block;
    width: 0;
    margin-top: 2px;
    height: 2px;
    background: #d2f02c;
    transition: width 0.3s;
  }
`;

const Footer = () => {
	const {isMobile} = useDeviceDetect();
	let navigate = useNavigate();

	const navigateTo = (link: string) => {
		if (link.startsWith('https')) {
			window.open(link, '_blank');
			return;
		}
		navigate(link);
	};

	return (
		<FooterContainer isMobile={isMobile}>
			<FooterVector src={FooterVectorIcon} isMobile={isMobile}/>
			<Box
				display="flex"
				flexDirection="column"
				marginRight={isMobile ? '0' : '15%'}
			>
				<img
					src={WakaoLogo}
					alt="Breakup Help"
					width={isMobile ? '128px' : '192px'}
					style={{marginBottom: '24px'}}
				/>
				{(
					<Block1HeadingSmall isMobile={isMobile}>
							<span
								style={{
									display: 'flex',
									height: 'fit-content',
									flexDirection: 'row',
									alignItems: 'center',
								}}
							>
              </span>
						©Breakup Help
					</Block1HeadingSmall>
				)}
			</Box>
			<Box
				display="flex"
				flexDirection="column"
				width="100%"
				alignItems="center"
			>
				<Box
					display="flex"
					flexDirection={isMobile ? 'column' : 'row'}
					alignItems="center"
					justifyContent="space-between"
					width="100%"
					marginBottom={isMobile ? '0' : '52px'}
				>
					<LinkText isMobile={isMobile} onClick={() => navigateTo('support')}>
						Support
					</LinkText>
					<LinkText
						isMobile={isMobile}
						onClick={() => navigateTo('cancellation-guidelines')}
					>
						Cancellation Guidelines
					</LinkText>

					<LinkText
						isMobile={isMobile}
						onClick={() => navigateTo('terms&conditions')}
					>
						Terms & Conditions
					</LinkText>
					<LinkText
						isMobile={isMobile}
						onClick={() => navigateTo('privacy-policy')}
					>
						Privacy Policy
					</LinkText>
				</Box>
			</Box>
			<FooterDots src={FooterDotsIcon} alt="." isMobile={isMobile}/>
		</FooterContainer>
	);
};

export default Footer;
